import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Navbar({ scrollToSection }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { label: "Story", id: "story" },
    { label: "The Protocol", id: "protocol" },
    { label: "The Science", href: "/science" },
    { label: "Buy The Book", id: "pricing" },
    { label: "Store", href: "/store" },
    { label: "Book Club Kit", href: "/book-club-kit" },
    { label: "Media Kit", href: "/media-kit" },
    { label: "Work With Merls", id: "work-with-merls" },
    { label: "Book Merls", id: "speaking" },
  ];

  const handleNav = (link) => {
    setMobileOpen(false);
    if (link.href) {
      window.location.href = link.href;
    } else if (scrollToSection) {
      scrollToSection(link.id);
    }
  };

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/90 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        <Link to="/" className="font-brand text-2xl tracking-tighter text-white flex-shrink-0 mr-6" data-testid="nav-logo">
          FYB
        </Link>

        {/* Desktop nav — only show on xl (1280px+) */}
        <div className="hidden xl:flex items-center gap-5">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link)}
              className="text-[11px] tracking-[0.08em] uppercase text-zinc-400 hover:text-[#D4AF37] transition-colors duration-300 font-medium whitespace-nowrap"
              data-testid={`nav-${link.id || link.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNav({ id: "pricing" })}
            className="btn-gold px-4 py-2 text-[11px] tracking-[0.12em] uppercase rounded-sm whitespace-nowrap flex-shrink-0"
            data-testid="nav-cta-button"
          >
            Purchase A Book Now
          </button>
        </div>

        {/* Hamburger toggle — show below xl */}
        <button
          className="xl:hidden text-white"
          onClick={() => setMobileOpen(!mobileOpen)}
          data-testid="mobile-menu-toggle"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile/tablet menu */}
      {mobileOpen && (
        <div className="xl:hidden bg-[#050505]/98 backdrop-blur-xl border-t border-white/10 px-6 py-6 space-y-4" data-testid="mobile-menu">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link)}
              className="block w-full text-left text-sm tracking-[0.1em] uppercase text-zinc-400 hover:text-[#D4AF37] transition-colors py-2"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNav({ id: "pricing" })}
            className="btn-gold w-full py-3 text-xs tracking-[0.15em] uppercase rounded-sm mt-4"
          >
            Purchase A Book Now
          </button>
        </div>
      )}
    </nav>
  );
}
